/**
 * Date query helpers — Angular reports send daterange fields as DD-MM-YYYY on the API.
 */

/** `YYYY-MM-DD` → `DD-MM-YYYY` for API query strings. */
export function ymdToDmy(ymd: string): string {
  if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return ''
  const [y, m, d] = ymd.split('-')
  return `${d}-${m}-${y}`
}

/** `DD-MM-YYYY` → `YYYY-MM-DD` when restoring session filters in React UI. */
export function dmyToYmd(dmy: string): string {
  if (!dmy || !/^\d{2}-\d{2}-\d{4}$/.test(dmy)) return ''
  const [d, m, y] = dmy.split('-')
  return `${y}-${m}-${d}`
}

/** Append `fromDt` / `toDt` from a flat map using DD-MM-YYYY values. */
export function appendDaterangeParams(
  params: URLSearchParams,
  fromDt: string | undefined,
  toDt: string | undefined,
): void {
  const from = fromDt ? ymdToDmy(fromDt) : ''
  const to = toDt ? ymdToDmy(toDt) : ''
  if (from) params.set('fromDt', from)
  if (to) params.set('toDt', to)
}
